import { render, staticRenderFns } from "./MinisiteHeader.vue?vue&type=template&id=67b0ceb8"
import script from "./MinisiteHeader.vue?vue&type=script&lang=js"
export * from "./MinisiteHeader.vue?vue&type=script&lang=js"
import style0 from "./MinisiteHeader.vue?vue&type=style&index=0&id=67b0ceb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports